var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArrowDownGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1912 2208",
    style: {
      enableBackground: "new 0 0 1912 2208"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#919294;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.45,879.76c0-41.04,15.66-82.08,46.99-113.41c62.61-62.66,164.21-62.66,226.82,0L980,1241.08l474.73-474.73 c62.61-62.66,164.21-62.66,226.82,0c62.66,62.66,62.66,164.16,0,226.82l-588.14,588.14c-62.61,62.66-164.21,62.66-226.82,0 L278.45,993.17C247.12,961.84,231.45,920.8,231.45,879.76z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDownGray);
export default __webpack_public_path__ + "static/media/icon-arrow-down-gray.07bc9f24bb88ceacd50cb5b913d655ea.svg";
export { ForwardRef as ReactComponent };